const relaysOnPlatform = [
  "wss://nostr-01.yakihonne.com",
  "wss://nostr-02.yakihonne.com",
  "wss://relay.damus.io",
  "wss://relay.nsec.app",
  "wss://nos.lol",
  "wss://monitorlizard.nostr1.com/",
];

const SSGRelays = [
  "wss://nostr-01.yakihonne.com",
  "wss://nostr-02.yakihonne.com",
  "wss://relay.damus.io",
  "wss://nos.lol",
  "wss://relay.primal.net",
];

const searchRelays = [
  "wss://search.nos.today",
  "wss://relay.ditto.pub",
  "wss://nostr.polyserv.xyz",
];

export { relaysOnPlatform, SSGRelays, searchRelays };
